import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 256 256"
    >
      <path fill="none" d="M0 0H256V256H0z" />
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
        d="M56.2 104a71.9 71.9 0 0172.3-72c39.6.3 71.3 33.2 71.3 72.9v7.1c0 35.8 7.5 56.6 14.1 68a8 8 0 01-6.9 12H49a8 8 0 01-6.9-12c6.6-11.4 14.1-32.2 14.1-68zM96 192v8a32 32 0 0064 0v-8"
      />
    </svg>
  );
}

export default Icon;
